// Create File Storage V2
export var createFileStorageV2StatusSelector = function createFileStorageV2StatusSelector(state) {
  return state.fileStorage.createFileStorageV2Status;
};
export var createFileStorageV2OutputSelector = function createFileStorageV2OutputSelector(state) {
  return state.fileStorage.createFileStorageV2Output;
}; // Upload File V2

export var uploadFileV2StatusSelector = function uploadFileV2StatusSelector(state) {
  return state.fileStorage.uploadFileV2Status;
}; // Validate Public File URL

export var validatePublicFileUrlStatusSelector = function validatePublicFileUrlStatusSelector(state) {
  return state.fileStorage.validatePublicFileUrlStatus;
};
export var validatePublicFileUrlOutputSelector = function validatePublicFileUrlOutputSelector(state) {
  return state.fileStorage.validatePublicFileUrlOutput;
}; // Get Many File V2

export var getManyFileV2StatusSelector = function getManyFileV2StatusSelector(state) {
  return state.fileStorage.getManyFileV2Status;
};
export var filesSelector = function filesSelector(state) {
  return state.fileStorage.files;
};
export var nextTokenSelector = function nextTokenSelector(state) {
  return state.fileStorage.nextToken;
}; // Delete File V2

export var deleteFileV2StatusSelector = function deleteFileV2StatusSelector(state) {
  return state.fileStorage.deleteFileV2Status;
};